<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Муниципальный район"
    no-data-text="Муниципальный район не найден"
    :request="request"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title
          class="body-2 font-weight-regular"
          style="white-space: initial;"
          v-text="item.name"
        />
        <v-list-item-subtitle
          v-if="item.region"
          class="font-weight-regular grey--text text--lighten-1"
          style="white-space: initial;"
          v-text="item.region.name"
        />
      </v-list-item-content>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { AteMunicipalitiesApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


const MODELS = [
  'User',
]

export default {
  name: 'BAutocompleteMunicipality',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    model: {
      type: String,
      required: true,
      validator: (prop) => MODELS.includes(prop),
    },
  },
  created() {
    const api = new AteMunicipalitiesApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.getAll({ ...params, model }, ...args)
    },
  },
}
</script>
